<template>
  <div>
    <div>
      <button type="button" class="btn btn--green my-3" @click="addExperience()">{{ __('misc.add') }}
      </button>
    </div>
      <div class="row py-2 px-4 justify-content-between">
        <div
        class="form-group hrtcard shadow my-3 p-3 col-12 col-md-5"      
        v-for="(row, index_exp) in workExperiences"
        v-bind:key="index_exp"
      >
      
          <div class="d-flex justify-content-end">
            <button
              type="button"
              class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove"
              @click="rmExperience(index_exp)"
            >
            <i class="fas fa-trash"></i>
            </button>
          </div>

        <div
          v-for="(element, index_element) in settings_question"
          class="row my-2"
          v-bind:key="index_element"        
        >
          <div style="margin:0 auto" class="col-12">
            <label v-if="element.eav_id != null">{{ eavs_plucked[element.eav_id] }}</label>
            <label v-else>{{ __(element.label) }}</label>          
          </div>
          <div style="margin:0 auto" class="col-12">
            <div v-if="element.type == 'string'">
              <input
                v-if="element.key == 'duty_name'"
                required
                type="text"
                class="form-control"
                value=""
                :name="
                  'question[' +
                  question_id +
                  '][work_experience_data][' +
                  index_exp +
                  '][' +
                  element.key +
                  ']'
                "
              />
              <input
                v-else
                type="text"
                class="form-control"
                value=""
                :name="
                  'question[' +
                  question_id +
                  '][work_experience_data][' +
                  index_exp +
                  '][' +
                  element.key +
                  ']'
                "
              />
            </div>
            <div v-if="element.type == 'number'">
              <input
                type="number"
                class="form-control"
                value=""
                :name="
                  'question[' +
                  question_id +
                  '][work_experience_data][' +
                  index_exp +
                  '][' +
                  element.key +
                  ']'
                "
              />
            </div>
            <div v-if="element.type == 'date'">
              <input
                type="date"
                class="form-control"
                value=""
                :name="
                  'question[' +
                  question_id +
                  '][work_experience_data][' +
                  index_exp +
                  '][' +
                  element.key +
                  ']'
                "
              />
            </div>
            <div v-if="element.type == 'select'">
              <select
                class="form-control"
                :name="
                  'question[' +
                  question_id +
                  '][work_experience_data][' +
                  index_exp +
                  '][' +
                  element.key +
                  ']'
                "
              >
                <option
                  v-for="(opt, index) in element.options"
                  :value="index"
                  v-bind:key="index"
                >
                  {{ opt }}
                </option>
              </select>
            </div>
            <div v-if="element.type == 'radio' || element.type == 'radiobutton'">
              <div v-for="(opt, index) in element.options" v-bind:key="index">
                <input
                  class="form-check-input"
                  type="radio"
                  :name="
                    'question[' +
                    question_id +
                    '][work_experience_data][' +
                    index_exp +
                    '][' +
                    element.key +
                    ']'
                  "
                  :value="index"
                />
                <label class="form-check-label">
                  {{ opt }}
                </label>
              </div>
            </div>
            <div v-if="element.type == 'checkbox'">
              <div v-for="(opt, index) in element.options" v-bind:key="index">
                <input
                  class="form-check-input"
                  type="checkbox"
                  :name="
                    'question[' +
                    question_id +
                    '][work_experience_data][' +
                    index_exp +
                    '][' +
                    element.key +
                    '][' +
                    index +
                    ']'
                  "
                  :value="index"
                />
                <label class="form-check-label">
                  {{ opt }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {},

  mounted() {
    console.log("ALL", this.work_experiences_all_fields);
    console.log("SETTINGS", this.settings_question);
    this.workExperiences = this.previous_work_experiences;
  },
  props: {
    settings_question: {
      type: Array,
      required: true,
    },
    previous_work_experiences: {
      type: Array,
      required: true,
    },
    question_id: {
      type: Number,
      required: true,
    },
    eavs_plucked: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      workExperiences: [],
    };
  },
  methods: {
    rmExperience(index) {
      this.workExperiences.splice(index, 1);
    },
    addExperience() {
      this.workExperiences.push([]);
    },

    populateSkillTable() {
      axios
        .get(
          "/skill-personal-table-chart/" +
            this.evaluation_chart_id +
            "/i-chart",
          {
            params: {
              question_survey_id: this.question_survey_id,
            },
          }
        )
        .then((response) => {
          this.tableDataSkillRoles = response.data.skills_roles;
          this.tableDataSkillPersonal = response.data.people_skills;
          console.log(this.tableDataSkillPersonal);
        });
    },
  },
};
</script>
<style scoped>
  .row > [class^="col-"]:not(:last-child) {
    margin-right: 15px;
}
</style>

